"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PlaceholderColors_1 = __importDefault(require("../../PrettyText/PlaceholderColors"));
const globalCodeMirrorStyles = {
    '.FieldsFormCodeMirror .CodeMirror': {
        height: 'auto',
        lineHeight: '20px',
        backgroundColor: 'unset',
    },
    '.FieldsFormCodeMirror--multiline .CodeMirror-code': {
        minHeight: '68px',
    },
    '.FieldsFormCodeMirror .CodeMirror-empty': {
        color: PlaceholderColors_1.default.default,
    },
    '.FieldsFormCodeMirror--errored .CodeMirror-empty': {
        color: PlaceholderColors_1.default.error,
    },
    '.FieldsFormCodeMirror .CodeMirror-empty:focus-within, .CodeMirror-empty:hover': {
        color: PlaceholderColors_1.default.focusedOrHovered,
    },
};
exports.default = globalCodeMirrorStyles;
